// Utilitario global de datas - DNACore
// REGRA: Data pura (YYYY-MM-DD) = string, sem timezone
// REGRA: Datetime (timestamp) = converter para SP na exibicao

/**
 * Formata data pura (YYYY-MM-DD) para DD/MM/YYYY sem conversao de timezone.
 * NUNCA usa new Date() para datas puras.
 */
export function formatDatePure(dateStr, opts) {
  if (!dateStr) return '-';
  const s = String(dateStr);
  // Extrair apenas YYYY-MM-DD (ignorar horario se existir)
  const match = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return s;
  const [, y, m, d] = match;
  if (opts?.weekday) {
    // Usar T12:00 para evitar shift de timezone
    const dt = new Date(`${y}-${m}-${d}T12:00:00`);
    const wd = dt.toLocaleDateString('pt-BR', { weekday: opts.weekday });
    return `${wd}, ${d}/${m}/${y}`;
  }
  return `${d}/${m}/${y}`;
}

/**
 * Formata datetime (timestamp) para exibicao em SP.
 */
export function formatDateTime(ts, opts) {
  if (!ts) return '-';
  return new Date(ts).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', ...opts });
}

/**
 * Formata valor monetario em BRL: R$ 1.234,56
 * Aceita centavos (int) ou reais (float).
 * @param {number} value - valor em reais (float) ou centavos (int se cents=true)
 * @param {boolean} cents - se true, divide por 100
 */
export function formatBRL(value, cents = false) {
  if (value === null || value === undefined) return 'R$ 0,00';
  const v = cents ? value / 100 : Number(value);
  return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

/**
 * Formata datetime para apenas data em SP.
 */
export function formatDateTimeSP(ts) {
  if (!ts) return '-';
  return new Date(ts).toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' });
}